import React, { useState, useEffect } from "react";
import Container from '@mui/material/Container';
import axios from "axios";
import { ArrowOutwardOutlined, Save, ShoppingBasket } from "@mui/icons-material";
import { Adminfetchconversationsurl, Fetchaccountsurl, Fetchsitevisitsurl } from "../../../utils/chaturls";
import { getsessionuser } from "../../../utils/sessions";
import Loadingspinner from "../../../components/Loadingspinner";
import { Erroralert, Successalert } from "../../../components/popups";
import Chart from "./chart";
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Shuffle, checknumber, formatDate, getissuecolor } from "../../../utils/functions";
import { columncolor } from "../../../utils/colors";
import { useNavigate } from "react-router-dom";



const Dashboard = ({ messagecounter }) => {
    const navigate = useNavigate()


    const user = getsessionuser()
    const [role, setrole] = React.useState('');
    const [loading, setloading] = useState(false);
    const [refreshdata, setrefreshdata] = useState('');

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [conversations, setconversations] = useState([])
    const [agents, setagents] = useState([]);


    const [partnerrequests, setpartnerrequests] = useState([]);
    const [sitevisits, setsitevisits] = useState([]);


    const [nodata, setnodata] = useState(false);


    useEffect(() => {
        fetchdata();
        fetchsitevisits()
        fetchagents()
    }, [refreshdata, messagecounter]);


    const fetchdata = async () => {
        setloading(true)
        try {
            setnodata(false);
            // setloading(true);
            const [conversationsResponse, agentsResponse] = await Promise.all([
                axios.post(Adminfetchconversationsurl, {
                    agentid: user.type === 'agent' && user.id
                }),
                axios.post(Fetchaccountsurl)
            ]);

            setloading(false);
            // Handle Conversations Response
            if (!conversationsResponse.data.error) {
                const conversationsData = conversationsResponse.data.reverse();
                if (conversationsData.length > 0) {
                    setconversations(conversationsData)
                } else {
                    setnodata(true);
                }
            } else {
                seterror(conversationsResponse.data.message);
            }

        } catch (error) {
            setloading(false);
            seterror('Sorry an error occurred, try again later');
            // Handle specific error response statuses if needed
        }
    };

    //fetch site visits
    const fetchsitevisits = () => {
        axios.post(Fetchsitevisitsurl).then(response => {
            if (!response.data.message) {
                setsitevisits(response.data)
            } else {
                seterror(response.data.message)
            }
        })
    }

    const fetchagents = async () => {
        axios.post(Fetchaccountsurl)
            .then(response => {
                if (!response.data.error) {
                    setagents(response.data)
                }
            })
    }














    return (
        <div>
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            {loading && <Loadingspinner />}

            <div className="routepathwrap">
                <div className="routepathmain">Dashboard</div>
                <div className="routepathminor"> / main Dashboard</div>
            </div>
            <Container maxWidth="lg" className="containerwithshadow" style={{ marginTop: 10 }}>
                <div className="wrapmoddivs">
                    <div className="wrapandivs">
                        <div className="slimdiv1" />
                        <div className="andivright">
                            <div className="andivrightdiv">
                                <div className="andivrighttext">ALL ISSUES</div>
                                <div className="andivrightpercent">
                                    <ArrowOutwardOutlined /> + 100%
                                </div>
                            </div><br />
                            <div className="andivrightdiv">
                                <div className="andivrightnumber">{conversations.length}</div>
                                <div className="shoppingiconprimary">
                                    <ShoppingBasket sx={{ color: "white", fontSize: 15 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapandivs">
                        <div className="slimdiv2" />
                        <div className="andivright">
                            <div className="andivrightdiv">
                                <div className="andivrighttext">SITE VISITS</div>
                                <div className="andivrightpercent2">
                                    <ArrowOutwardOutlined /> %
                                </div>
                            </div><br />
                            <div className="andivrightdiv">
                                <div className="andivrightnumber">{sitevisits?.length}</div>
                                <div className="shoppingiconprimary2">
                                    <ShoppingBasket sx={{ color: "white", fontSize: 15 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapandivs">
                        <div className="slimdiv3" />
                        <div className="andivright">
                            <div className="andivrightdiv">
                                <div className="andivrighttext">PARTNER REQUESTS</div>
                                <div className="andivrightpercent3">
                                    <ArrowOutwardOutlined />
                                </div>
                            </div><br />
                            <div className="andivrightdiv">
                                <div className="andivrightnumber">{partnerrequests?.length}</div>
                                <div className="shoppingiconprimary3">
                                    <ShoppingBasket sx={{ color: "white", fontSize: 15 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
            <Container disableGutters={true} maxWidth="lg" className="containerwith" style={{ marginTop: 20 }}>
                <div >
                    <Chart sitevisits={sitevisits} />
                    <div style={{ display: "flex", marginTop: 30 }}>
                        <div className="agentsdiv">
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ fontWeight: 800, fontSize: 20 }}>Agents</div>
                            </div>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">ID</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Name</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Tel</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Email</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Status</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Last Login</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ overflow: 'auto' }}>
                                        {Shuffle(agents).slice(0, 5).map((row, key) => {
                                            return (
                                                <TableRow
                                                    style={{ background: checknumber(key) ? columncolor : "white" }}
                                                    key={key}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell><img src={row.profileurl} className="userminipic" /></TableCell>
                                                    <TableCell sx={{ display: "flex", position: "relative" }}>{row.status == '1' ? <div className="availabledot" /> : <div className="notavailabledot" />} {row.id}</TableCell>
                                                    <TableCell component="th" scope="row" sx={{ fontSize: 12 }}> {row.username}  </TableCell>
                                                    <TableCell sx={{ fontSize: 12 }}>{row.phone}</TableCell>
                                                    <TableCell sx={{ fontSize: 12 }}>{row.email}</TableCell>
                                                    <TableCell sx={{ fontSize: 12 }}>{row.status == '1' ? 'Available' : 'Occupied'}</TableCell>
                                                    <TableCell sx={{ fontSize: 10 }}>{row.lastlogin}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                {agents.length > 0 &&
                                    <Button onClick={() => {
                                        navigate("/supportdashboard/agents")
                                    }} variant="text" sx={{ alignSelf: "flex-end" }}>See All</Button>
                                }
                            </div>
                        </div>
                        <div className="agentsdiv">
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ fontWeight: 800, fontSize: 20 }}>Conversations</div>
                            </div>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: "bold" }}>Convo Id</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Ticket</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Agent</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Status</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }} align="left">Date Created</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ overflow: 'auto' }}>
                                        {
                                            conversations?.slice(0, 5).map((row, key) => {
                                                const messages = row.messages;
                                                const unread = (messages.filter((obj) => obj.readstatus === 0)).length;
                                                return (
                                                    <TableRow
                                                        style={{ background: checknumber(key) ? columncolor : "white" }}
                                                        key={key}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row" sx={{ position: "relative" }}>
                                                            {row.id}{unread > 0 && <div className="availabledot" />}
                                                        </TableCell>
                                                        <TableCell> {row.ticket} </TableCell>
                                                        <TableCell>
                                                            <div>
                                                                {row?.agent?.username}<br />
                                                                {row?.agent?.phone}<br />
                                                            </div>
                                                        </TableCell>
                                                        <TableCell style={{ fontWeight: "bolder", borderRadius: "20%", color: getissuecolor(row.status) }} >  {row.status} </TableCell>
                                                        <TableCell>{formatDate(row.created_at)} </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                {conversations.length > 0 &&
                                    <Button onClick={() => {
                                        navigate("/supportdashboard/conversations")
                                    }} variant="text" sx={{ alignSelf: "flex-end" }}>See All</Button>}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Dashboard
